import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import { Marker } from "react-leaflet";
import { MAP_DEFAULT_VIEWPORT } from "../../config/constants";
import translator from "../localization/translator";
import AutocompleteInput from "../common/elements/AutocompleteInput";
import FooterButtons from "../common/elements/FooterButtons";
import {
    searchAddress,
} from "../../modules/OrderDetails/orderDetails.actions";

import Maps from "./Maps";
import Notifier from "../message/Notifier";

const defaultViewport = [MAP_DEFAULT_VIEWPORT.lat, MAP_DEFAULT_VIEWPORT.lng];

class ReceiverMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            center: defaultViewport,
            showMap: this.props.showMap,
            zoom: 16,
            addressKey: this.props.addressKey,
            openAutoCompleteSelect: true,
            suggestedAddresses: null,
            isAddressFromSuggestion: true,
        };
        this.handleSearchAddress = this.handleSearchAddress.bind(this);
        this.onHide = this.onHide.bind(this);
        this.handleSaveAddress = this.handleSaveAddress.bind(this);
        this.handleAddressInputChange = this.handleAddressInputChange.bind(this);
        this.handleSelectAddress = this.handleSelectAddress.bind(this);
        this.handleMapClick = this.handleMapClick.bind(this);
        this.reverseGeocode = this.reverseGeocode.bind(this);
    }

    async reverseGeocode(latlng) {
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latlng.lat}&lon=${latlng.lng}&addressdetails=1&accept-language=hy`,
            );
            const data = await response.json();

            if (data && data.display_name) {
                return data.display_name;
            }
            return `${latlng.lat}, ${latlng.lng}`;
        } catch (error) {
            console.error("Reverse geocoding failed:", error);
            return `${latlng.lat}, ${latlng.lng}`;
        }
    }

    async handleMapClick(e) {
        const newLocation = e.latlng;

        // Update marker position and enable save button
        this.setState({
            center: newLocation,
            isAddressFromSuggestion: true, // Enable save button
        });

        // Reverse geocode to get address
        const address = await this.reverseGeocode(newLocation);

        // Update the input field with the address
        this.setState({
            addressKey: address,
        });

        // Optionally search for suggestions based on this address
        if (address && address.length >= 5) {
            this.props.searchAddress(this.correctSearchText(address), (data) => {
                this.setState({
                    suggestedAddresses: data,
                });
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.addressKey && this.props.addressKey !== nextProps.addressKey) {
            this.setState({
                addressKey: nextProps.addressKey,
            });

            this.handleSearchAddress(nextProps.addressKey);

        } else if (nextProps && nextProps.addressKey && this.props.addressKey &&
            this.props.addressKey == nextProps.addressKey && nextProps.orderDetails.receiver &&
            this.props.addressKey == nextProps.orderDetails.receiver.address && this.state.center == defaultViewport
            && this.props.orderDetails.suggestedAddresses == nextProps.orderDetails.suggestedAddresses) {
            this.handleSearchAddress(nextProps.addressKey, true);
        }
        if (nextProps && nextProps.viewport && nextProps.viewport.center && (!this.props.viewport || this.props.viewport.center !== nextProps.viewport.center
            || this.state.center == defaultViewport) && this.state.center !== nextProps.viewport.center) {
            this.setState({
                center: nextProps.viewport.center,
            });
        } else if (!this.state.center && (!nextProps.viewport || !nextProps.viewport.center)) {
            this.setState({
                center: defaultViewport,
            });
        }
    }

    onHide(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.setState({
            center: defaultViewport, isAddressFromSuggestion: true,
        });
        this.props.onHide();
    }

    handleSaveAddress() {
        const saveResult = this.props.saveAddress(this.state.center, this.state.addressKey);

        if (saveResult && saveResult.catch) {
            saveResult.catch(() => {
                Notifier.error("Հասցեին համապատասխան տեղադիրքի ստացումը ձախողվեց։ Անհրաժեշտ է հասցեն նշել քարտեզի վրա։", "_error_");
            });
        } else if (saveResult === false) {
            Notifier.error("Հասցեին համապատասխան տեղադիրքի ստացումը ձախողվեց։ Անհրաժեշտ է հասցեն նշել քարտեզի վրա։", "_error_");
        }
    }

    renderFooter() {
        return (
            <Modal.Footer>
                <FooterButtons
                    cancelButton={translator.translate("_cancel_")}
                    saveButton={translator.translate("_save_")}
                    save={this.handleSaveAddress}
                    cancel={this.onHide}
                    isDisabled={!this.state.isAddressFromSuggestion} />
            </Modal.Footer>
        );
    }

    renderMarker() {
        return <Marker position={this.state.center} />;
    }

    handleSelectAddress(address) {
        if (address && address.length) {
            const location = { lat: Number(address[0]?.lat), lng: Number(address[0]?.lng) };
            this.setState({
                center: location,
                openAutoCompleteSelect: false,
                zoom: 16,
                addressKey: address[0]?.address,
                isAddressFromSuggestion: true,
            });
        } else {
            this.setState({ isAddressFromSuggestion: false });
        }
    }

    handleAddressInputChange(key) {
        this.setState({ isAddressFromSuggestion: false });
        this.handleSearchAddress(key);
    }

    handleSearchAddress(key, force = false) {
        this.setState({ addressKey: key });

        setTimeout(() => {
            if ((this.state.addressKey.length >= 5 && this.state.addressKey !== this.searchedAddress) || force) {
                // this.searchedAddress = this.state.addressKey;
                this.props.searchAddress(this.correctSearchText(this.state.addressKey), (data) => {
                    this.setState({
                        suggestedAddresses: data,
                    });

                    if (this.props.orderDetails && this.props.orderDetails.receiver && this.props.orderDetails.receiver.location || (!this.props.orderDetails.receiver?.location && this.props.orderDetails.receiver?.address)) {
                        return;
                    }
                    if (data && data.length) {
                        // this.handleSelectAddress([data[0]]);
                    }
                });
            }
        }, 1000);
    }

    correctSearchText(text) {
        return encodeURIComponent(text + ", Yerevan, Armenia");
    }

    onZoom(event) {
        this.setState({ zoom: event.target._zoom });
    }

    render() {
        return (<Modal
            show={this.props.show}
            dialogClassName="large-modal"
            onHide={this.onHide}
            backdrop={"static"}
            onKeyPress={this.props.onKeyPress}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {translator.translate("_map_")}
                </Modal.Title>
            </Modal.Header>
            <div style={{ padding: 15 }}>
                <AutocompleteInput
                    doNotFilter={true}
                    labelKey={"address"}
                    value={this.state.addressKey}
                    name={"search-address"}
                    items={this.props.orderDetails.suggestedAddresses || []}
                    onChange={this.handleSelectAddress}
                    onInputChange={this.handleAddressInputChange}
                    open={this.state.openAutoCompleteSelect}
                    onFocus={() => {
                        this.setState({ openAutoCompleteSelect: true });
                    }}
                    onBlur={() => {
                        this.setState({ openAutoCompleteSelect: false });
                    }} />
            </div>

            <Modal.Body className="scrollable modal-possition">
                <Maps
                    onZoom={this.onZoom.bind(this)}
                    viewport={{ center: this.state.center, zoom: this.state.zoom }}
                    markers={this.renderMarker()}
                    onClick={this.handleMapClick} // Changed to use the new handler
                />
            </Modal.Body>
            {this.renderFooter()}
        </Modal>);
    }
}

let mapStateToProps = (state) => {
    return {
        orderDetails: state.orderDetails,
    };
};

export default connect(mapStateToProps, { searchAddress })(ReceiverMap);
